module.exports = __webpack_public_path__ + "static/marc-benioff-51bedce56d161294d4ef8e17d56fd40e.jpg";